module.exports = __webpack_public_path__ + "static/media/bco.8d692a33.svg";